import { useForm } from 'antd/lib/form/Form';
import { useEffect, useState } from 'react';
import moment from 'moment';
import { editProductionCalendarDate } from 'services/api';
import type { CalendarEvent } from 'features/production-calendar/components/List/model/types';
import type { DateFormValues } from '../../types';

interface UseCreateDateServiceProps {
  hide: () => void;
  onItemEdit: () => void;
  calendarEvent: CalendarEvent | null;
}

export const useEditDateService = ({
  hide,
  onItemEdit,
  calendarEvent,
}: UseCreateDateServiceProps) => {
  const [form] = useForm<DateFormValues>();
  const [loading, setLoading] = useState(false);

  const hideModal = () => {
    hide();
    form.resetFields();
  };

  const onSubmit = () => {
    form.validateFields().then((values) => {
      setLoading(true);
      editProductionCalendarDate({
        id: calendarEvent!.id,
        holiday: values.holiday === 'true',
        date: values.date.format('YYYY-MM-DD'),
        description: values.description,
      })
        .then(() => {
          hideModal();
          onItemEdit();
        })
        .finally(() => {
          setLoading(false);
        });
    });
  };

  useEffect(() => {
    if (calendarEvent) {
      form.setFieldsValue({
        date: moment(calendarEvent.date),
        holiday: calendarEvent.holiday.toString(),
        description: calendarEvent.description,
      });
    }
  }, [calendarEvent]);

  return {
    state: { form, loading },
    methods: { hideModal, onSubmit },
  };
};
